export default { sha: '707467f5b90c7a41377aa5d11ce08e16fafbd928', buildNumber: 'undefined' }
